import {
    /** FETCH APPLICATION  */
    FETCH_UPDATEAPPLICATIONSTATUS_FULFILLED,
    FETCH_UPDATEAPPLICATIONSTATUS_REJECTED,
    FETCH_UPDATEAPPLICATIONSTATUS_PENDING,
    RESET_UPDATEAPPLICATIONSTATUS
} from "../../actions/application/updateApplicationStatus";
const initialState = {
    done: false,
    error: false,
    spinner: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_UPDATEAPPLICATIONSTATUS_PENDING:
            return {
                done: false,
                error: false,
                spinner: true,
            };
        case FETCH_UPDATEAPPLICATIONSTATUS_FULFILLED:
            localStorage.setItem("applicationId", action.payload.id)
            return {
                ...state,
                updateApplicationStatus: action.payload,
                done: true,
                spinner: false,
            };
        case FETCH_UPDATEAPPLICATIONSTATUS_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false,
            };
        case RESET_UPDATEAPPLICATIONSTATUS:
            return {
                ...state,
                done: false,
                error: false,
                spinner: false,
            };
        default:
            return state;
    }
};